module.exports = __webpack_public_path__ + "img/img1.4e323807.png";